import { z } from 'zod';
export const healthSchema = z.object({
    status: z.literal('ok'),
    /** Confirms the process can actually reach its database, not merely that it is up. */
    database: z.enum(['reachable', 'unreachable']),
});
//# sourceMappingURL=health.js.map